import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import PrintFileApi from "service/PrintFileApi";
import { AGREEMENT_CONTENT } from "constants/agreementContent";
import userApi from "service/userApi";
import { setToken } from "utils/cookieExtension";

export const ModalThoaThuanSuDung = (props) => {
  const [agreementHtml, setAgreementHtml] = useState("");
  const [loading, setLoading] = useState(false);
  const [isAgreed, setIsAgreed] = useState(true); // Mặc định tích chọn
  const [isAgreeing, setIsAgreeing] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({
    companyName: props.customerInfoInit?.companyName || "",
    address: props.customerInfoInit?.address || "",
    phone: props.customerInfoInit?.phone || "",
    email: props.customerInfoInit?.email || "",
    username: props.customerInfoInit?.email || "",
  });
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "ThoaThuanSuDung",
  });

  const handleHide = () => {
    if (props.onHide) {
      props.onHide();
    } else if (props.onClose) {
      props.onClose();
    }
  };
  useEffect(() => {
    const fetchAgreement = async () => {
      setLoading(true);
      try {
        const response = await PrintFileApi.getDieuKhoan();
        if (response && response.ok && response.data) {
          setAgreementHtml(response.data.ThoaThuan);
        } else {
          console.warn(
            "API không trả về dữ liệu thỏa thuận, dùng dữ liệu mặc định",
          );
          setAgreementHtml(AGREEMENT_CONTENT);
        }
      } catch (err) {
        console.warn("Lỗi gọi API thỏa thuận, dùng dữ liệu mặc định:", err);
        setAgreementHtml(AGREEMENT_CONTENT);
      } finally {
        setLoading(false);
      }
    };

    const fetchUserInfo = async () => {
      try {
        const res = await userApi.getAllUserInfor();
        if (res.data && res.data.enUser) {
          setCustomerInfo({
            companyName: res.data.enUser.FirstName || "",
            address: res.data.enUser.Address || "",
            phone: res.data.enUser.Phone || "",
            email: res.data.enUser.Email || "",
            username: res.data.enUser.UserName || "",
          });
        }
      } catch (err) {
        console.warn("Lỗi lấy thông tin user:", err);
      }
    };

    if (props.show) {
      fetchAgreement();
      // Chỉ gọi API nếu không có dữ liệu từ URL params
      if (!props.customerInfoInit) {
        fetchUserInfo();
      }
    }
  }, [props.show, props.customerInfoInit]);

  const handleAgree = async () => {
    if (!isAgreed || isAgreeing) return;
    setIsAgreeing(true);
    try {
      setToken("isAgreeThoaThuanSuDung", "1");
      setToken("agreeTimeThoaThuanSuDung", new Date().toISOString());
      const email = customerInfo.username || customerInfo.email;
      if (email) {
        await userApi.capNhatTrangThaiThoaThuan(email);
      }
      if (props.onAgree) {
        props.onAgree();
      }
    } finally {
      setIsAgreeing(false);
    }
  };

  const modalCustomStyle = `
    .modal-70 {
      max-width: 90vw !important;
      width: 90vw !important;
    }
    .modal-70 .modal-content {
      width: 100%;
    }
  `;

  return (
    <>
      <style>{modalCustomStyle}</style>
      <Modal
        {...props}
        dialogClassName="modal-70"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img
                src={"/app-assets/images/icon-editphieuthuchi.png"}
                alt="icon"
              />
            </span>
            Thảo thuận sử dụng phần mềm
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div>
            {/* Thông tin khách hàng */}
            <div
              style={{
                marginBottom: "20px",
                padding: "15px",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
                border: "1px solid #dee2e6",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "20px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    fontSize: "16px",
                    flex: 1,
                  }}
                >
                  <div>
                    <strong>Tên công ty/cửa hàng:</strong>{" "}
                    {customerInfo.companyName || "Chưa cập nhật"}
                  </div>
                  <div>
                    <strong>SĐT:</strong>{" "}
                    {customerInfo.phone || "Chưa cập nhật"}
                  </div>
                  <div>
                    <strong>Email:</strong>{" "}
                    {customerInfo.email || "Chưa cập nhật"}
                  </div>
                  <div>
                    <strong>Địa chỉ:</strong>{" "}
                    {customerInfo.address || "Chưa cập nhật"}
                  </div>
                </div>
                <img
                  src="/app-assets/images/logo/logo-dark.png"
                  alt="Logo"
                  style={{
                    height: "80px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
              </div>
            </div>

            <div
              style={{
                maxHeight: "35vh",
                overflowY: "auto",
                lineHeight: 1.8,
              }}
              dangerouslySetInnerHTML={{
                __html: loading
                  ? "<p>Đang tải thỏa thuận...</p>"
                  : agreementHtml,
              }}
            />

            {/* Checkbox đồng ý */}
            <div
              style={{
                marginTop: "20px",
                padding: "15px",
                backgroundColor: "#fff3cd",
                borderRadius: "8px",
                border: "1px solid #ffeaa7",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="checkbox"
                  id="agreeCheckbox"
                  checked={isAgreed}
                  onChange={(e) => setIsAgreed(e.target.checked)}
                  style={{ width: "18px", height: "18px" }}
                />
                <label
                  htmlFor="agreeCheckbox"
                  style={{ margin: 0, fontWeight: "bold", color: "#856404" }}
                >
                  Tôi đồng ý với Thỏa thuận sử dụng dịch vụ
                </label>
              </div>
            </div>

            {/* Nút kích hoạt */}
            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                className="btn btn-new-main btn-checknew"
                onClick={handleAgree}
                disabled={!isAgreed || isAgreeing}
              >
                {isAgreeing ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1" role="status" />
                    &nbsp; Đang xử lý... &nbsp;
                  </>
                ) : (
                  <>
                    <span><i className="fas fa-check me-1"></i></span>
                    &nbsp; Kích hoạt sử dụng phần mềm &nbsp;
                  </>
                )}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div style={{ display: "none" }}>
        <div
          id="htmlPrint"
          ref={printRef}
          className="print-content-wrapper"
          dangerouslySetInnerHTML={{ __html: agreementHtml }}
        />
      </div>
    </>
  );
};
